export default __webpack_public_path__ + "static/media/cast-agency.2315150c.svg";